import React from 'react';
import * as util from "../../../other/util.js";
import FleetFormulas from "../../../share/formulas/fleet-formulas.js";
import FleetStep from "./fleet-step.js";

export class PendingMoveFleetStep extends FleetStep {
    constructor() {
        super("MOVE");
    }

    doPreRenderPredictions(props, idx) {
        let task = props.task;
        let fleet = props.fleet;
        let from = props.prediction.location;
        let to = task.location;
        props.prediction.removeCertainFuel(FleetFormulas.getFuelForMove(fleet, from, to));
    }

    doPostRenderPredictions(props, idx) {
        props.prediction.updateLocation(props.task.location);
    }

    render(props, idx) {
        let task = props.task;
        let fleet = props.fleet;
        let from = props.prediction.location;
        let to = task.location;

        let duration = FleetFormulas.getTimeForMove(fleet, from, to);
        let fuel = FleetFormulas.getFuelForMove(fleet, from, to);

        return (
            <div>
                <util.FuelEstimation fuel={props.prediction} />
                <util.PlanetInput planet={task.location} onChange={(x, y, z) => this._onPlanetChange(props, x, y, z)} />
                <util.Fuel fuel={fuel} />
                <br />
                <span>
                    <span className="boring-info-text">Travel time: </span>
                    <util.NiceInlineTimeSpan timeSpan={duration} />
                </span>
            </div>);
    }
}

export class FixedMoveFleetStep extends FleetStep {
    doPreRenderPredictions(props, idx) {
        if (!this._hasStepStarted(props, idx)) {
            props.prediction.removeCertainFuel(props.task.steps[idx].fuel);
        }
    }

    doPostRenderPredictions(props, idx) {
        if (!this._isStepDone(props, idx)) {
            props.prediction.updateLocation(props.task.steps[idx].location);
        }
    }

    render(props, idx) {
        let task = props.task;
        let step = task.steps[0];

        let timer = (<util.NiceInlineTimeSpan timeSpan={step.duration} />);
        if (task.index === 0) {
            timer = (<util.Timer date={step.finished} style={{ display: "inline" }} />);
        }

        return (
            <div>
                <util.FuelEstimation fuel={props.prediction} />
                <util.PlanetLink planet={step.location} showOwner={true} />
                <br />
                <util.Fuel fuel={step.fuel} />
                <br />
                <span>
                    <span className="boring-info-text">Travel time: </span>
                    {timer}
                </span>
            </div>);
    }
}
